import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Model, Trim, VehicleDetails } from '../../shared/models/series-data';
import { Store } from '@ngrx/store';
import { combineLatest, iif, Observable, Subject } from 'rxjs';
import { SalesAppointmentState } from '../../store/sales-appointment/sales-appointment.reducer';
import * as fromActions from '../../store/sales-appointment/sales-appointment.actions';
import * as fromSelectors from '../../store/sales-appointment/sales-appointment.selectors';
import { SubscriptionList } from '../../shared/models/asp.types';
import { confirmConfig, environment, unsubscribeSubscriptions } from '../../shared/services/util.service';
import _ from 'lodash';
import { filter, take } from 'rxjs/operators';
import { ICustomer, IAvailabilityOptions, IAvailability, LocationType, AppointmentType, IVehicle, SourceSystem, Brand } from '@signal/asp-data-commons';
import { IGeneralSettingsAppointmentRequest, ITransportOption } from '@signal/asp-data-commons/lib/interfaces/general-setttings';
import { DateTime } from 'luxon';
import { SearchCustomersState } from '../../store/search-customers/search-customers.reducer';
import { selectCurrentCustomer, selectPendingSearchInput } from '../../store/search-customers/search-customers.selectors';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { SettingsState } from '../../store/settings/settings.reducer';
import { LoadSettings } from '../../store/settings/settings.actions';
import { TranslateService } from '@ngx-translate/core';
import { VehiclesState } from '../../store/vehicle/vehicle.reducer';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { VehicleService } from '../../shared/services/vehicle.service';
import * as fromValidator from '../service-appointment/service-appointment.validator';
import { AvailabilityComponent } from '../../shared/components/availability/availability.component';
import * as fromSettingsSelectors from "../../store/settings/settings.selectors";
import { CustomerType } from '../../shared/enums/customer-types.enum';

@Component({
  selector: 'app-test-drive',
  templateUrl: './testdrive.component.html',
  styleUrls: ['./testdrive.component.scss']
})
export class TestdriveComponent implements OnInit, OnDestroy {
  testDriveForm: UntypedFormGroup;
  signedIn: boolean;
  appointmentId: string;
  isSubmitting: boolean;
  isUpdate = false;
  showMandatoryMsgCI:boolean = false;
  isStoreUpdate = false;
  isValidRemoteZip = false;
  hasRemoteLocation = false;
  hasremoteLocationType = false;
  transport;
  validatedFields = ['year', 'model', 'trim'];
  otherVehicleChecked = false;
  isCustomerPanelExpanded=false;
  previousZip='';
  apptType: string = AppointmentType.TEST_DRIVE;
  vehicleDetails: any = {
    yearMakeModel: '',
    vin: '',
    stockno: 'P6392',
    trim: 'XE',
    certificationStatus:'',
    source:'',
    make:'',
    isTestDrive: true
  };
  searchWithVin = false;
  vehicleDetailsEdit:any = {
    yearMakeModel: '',
    vin: '',
    stockno: 'P6392',
    trim: 'XE',
    certificationStatus:'',
    source:'',
    make:'',
    isTestDrive: true
  }
  sourcetype = ""; 
  @ViewChild(AvailabilityComponent, { static: false }) AvailabilityComponent: AvailabilityComponent;

  /* All 4 steps are sub form - Accessible only through the main form */
  private vehicleForm: UntypedFormControl;
  private otherVehiclesForm: UntypedFormArray;
  private tradeInForm: UntypedFormControl;
  searchVinForm:UntypedFormGroup;
  availability: UntypedFormControl;
  private customerForm: UntypedFormControl;
  private contactEmailInfoForm: UntypedFormControl;

  availabilityOptions$: Observable<IAvailabilityOptions>;
  availabilityOptionsLoading$: Observable<boolean>;
  availability$: Observable<IAvailability>;
  availabilityLoading$: Observable<boolean>;
  transportOptions$: Observable<ITransportOption[]>;
  remoteZipcodes$: Observable<string[]>;
  yearList$: Observable<number[]>;
  modelList$: Array<Observable<Model[]>> = [];
  trimList$: Array<Observable<Trim[]>> = [];
  vehicleDetails$: Observable<VehicleDetails>;
  customerDetails$: Observable<ICustomer>;
  remoteValidZipcodes: { pmaZipCodes: string[], isRemote: boolean };
  subscriptions: SubscriptionList = {};
  vinTestDrive:string = '';
  dateFormat : string = 'yyyy-MM-dd';
  
  withoutFleetVehicle: boolean = false;
  fullDataWithYear;
  appointmentVehicle;
  isLoaded$: Observable<boolean>;
  fullDataWithYearSchedule$: Observable<any>;

  lastValue: any;
  private storeValue: any;
  private signedInUserDetails: ICustomer;
  testDriveVins: string = '';
  valueChanged=true;
  aptType: string = AppointmentType.TEST_DRIVE;
  load:boolean = false;
  isVinValid:boolean = false;
  loadingAvailability = false;
  isLexus = environment.brand === Brand.LEXUS.toLocaleLowerCase();
  sourceMap:any = {
    [this.translateService.instant('serviceSchedule.others')] : SourceSystem.ME,
    [this.translateService.instant('serviceSchedule.new')] : SourceSystem.NVI,
    [this.translateService.instant(this.isLexus ? 'otherTexts.preOwned' : 'serviceSchedule.used')] : SourceSystem.UVI,
    "CRM" : SourceSystem.CRM
  };
  languageId='';
  customerDataOnEdit;
  validVehicleForm = true;
  settings:IGeneralSettingsAppointmentRequest={} as IGeneralSettingsAppointmentRequest;
  paramVin='';
  constructor(
    private readonly dialog: MatDialog,
    private readonly viewportScroller: ViewportScroller,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly salesAppointmentState: Store<SalesAppointmentState>,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly vehiclesState: Store<VehiclesState>,
    private readonly settingsState: Store<SettingsState>,
    private readonly vehicleService:VehicleService,
    private bannerService:AspBannerService,
    private readonly translateService:TranslateService,
    private cd: ChangeDetectorRef) {
    this.apptType = AppointmentType.TEST_DRIVE;
    this.searchVinForm = this.formBuilder.group({
      isOwnVehicle: [false],
      isInputVinBased: [true],
      vin: ['',[Validators.required]],
      mileage:[1]
    })
    this.searchVinForm.setValidators(fromValidator.chooseVehicleValidator());
    this.initializeTestDriveForm();
    this.settingsState.dispatch(new LoadSettings({department: 'sales'}));

    this.subscriptions.query = this.route.queryParams.subscribe( params => {
      if(params.vin) {
        this.paramVin = params.vin;
        this.sourcetype = params.source?.toLocaleUpperCase() ?? "";
        this.searchVinForm.patchValue({
          isOwnVehicle: false,
          isInputVinBased: true,
          vin: this.paramVin
        });
      }
      if(params && params.id && params.id.length === 17){
        this.vinTestDrive = params.id;
        const vehicle = {} as IVehicle;
        vehicle.vin = this.vinTestDrive;
      } else {
        this.vinTestDrive = '';
        this.appointmentId = params.id;
        if (this.appointmentId) {
          this.salesAppointmentState.dispatch(new fromActions.GetEditData
              ({appointmentType: AppointmentType.TEST_DRIVE, appointmentId: this.appointmentId }));
              this.isUpdate = true
              this.searchWithVin = true
        }
      }
    });
  }
  canExit():Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, confirmConfig);
    return new Observable<boolean>(observer => {
      this.subscriptions.dialogRef = dialogRef.afterClosed().pipe(take(1)).subscribe(event => {
        observer.next(event?.action === 'close');
        observer.complete();
      });

      return this.subscriptions.dialogRef;
    });
  };

  // returns if the forms are edited
  formsNotEdited()
  {
    return this.valueChanged;
  }

  formValuesChanges(event)
  {
    this.valueChanged=event;
  }

  isCIformValid(event) {
    this.showMandatoryMsgCI = event;
  }

  sourceChanged(event : any){
    if(event?.type === "Changes"){
      if(event?.data?.source.length){
        event.data.source = this.sourceMap[event.data.source]
      }
      this.testDriveForm.controls.vehicle.patchValue({ ...event?.data})
    }
    if(event?.type === "loaded"){
      this.vehicleDetails = {
        yearMakeModel: '',
        vin: '',
        stockno: '',
        trim: '',
        certificationStatus:'',
        source:'',
        make:'',
        isTestDrive: true
      };
      
    }
    if(event?.type === "sourceChanged"){
      if(event?.data?.source.length){
        event.data.source = this.sourceMap[event.data.source]
      }
      this.testDriveForm.controls.vehicle.patchValue({ ...event?.data})
      this.searchWithVin = false;
      this.searchVinForm.patchValue({
        isOwnVehicle: false,
        isInputVinBased: true,
        vin: "",
        mileage:1
      })
      this.searchVinForm.markAsUntouched()
    }
  }

  /* *this function is used to deal with if appointment vehicle is deleted or status is false */
  findNestedObj(entireObj, keyToFind, valToFind) {
    let foundObj;
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (nestedValue && nestedValue[keyToFind] === valToFind) {
        foundObj = nestedValue;
      }
      return nestedValue;
    });
      
    if(!foundObj) {
        return null;
    }
    
    return foundObj;
  };

  ngAfterContentChecked(): void {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

  onSearchChange(): void {  
    this.vehicleDetails.isInvalid = false
    this.vehicleDetails.notAvailable = false
  }

  submitVinForm(){
    this.onSearchChange()
    if(this.searchVinForm.valid){
        this.load = true
        this.searchWithVin = true;
        this.subscriptions.vehicleDetails = this.vehicleService.getVehicleFromVin(this.searchVinForm.get('vin')?.value).subscribe(result => {
          if(result?.data?.length){
            const data = result.data[0]
            if(data.vin && data.make && data.model && data.year && this.searchWithVin){
              this.load = false
              this.vehicleDetails.yearMakeModel = `${data.year} ${data.make} ${data.model}`
              this.vehicleDetails.vin = data.vin
              this.vehicleDetails.isInvalid = false
              this.vehicleDetails.make=data.make;
              this.vehicleDetails.certificationsStatus=data.certificationStatus;
              this.vehicleDetails.source= data.sourceSystem ? data.sourceSystem : data.source;
              this.vehicleDetails.stockNo= this.vehicleDetails.source === "Manual" ? data.licensePlate : data.stockNo;
              this.bannerService.showCarImage()
              this.bannerService.update(data.imageUrl)
              this.testDriveForm.get('vehicle').patchValue({
                model: data.model,
                year: data.year,
                make: data.make,
                imageUrl: data.imageUrl,
                vin: data.vin,
                source: data.sourceSystem ? data.sourceSystem : data.source,
                description: `${data.make} ${data.model}`,
                dealerCode: data?.dealerCode,
                unitId: data?.unitId ? data?.unitId : ""
                })
              this.isVinValid = true
            }else{
              this.load = false
              this.isVinValid = false
              this.vehicleDetails.isInvalid = false
              this.vehicleDetails.notAvailable = true
              this.vehicleDetails.yearMakeModel = ''
              this.vehicleDetails.vin = ''
            }
          }else{
            this.load = false
            this.isVinValid = false
            this.vehicleDetails.isInvalid = true
            this.vehicleDetails.yearMakeModel = ''
            this.vehicleDetails.vin = ''
          }
        })
    }
  }


  ngOnInit() {
    this.previousZip='';
    this.viewportScroller.scrollToPosition([0, 0]);
    this.bannerService.update('');
    this.bannerService.show();
    this.setupStoreValue();
    this.paramVinSearch();
    this.validVehicleForm = this.checkvehicleForm(this.testDriveForm?.controls?.vehicle?.value) ? this.checkvehicleForm(this.testDriveForm?.controls?.vehicle?.value) : false;
  }

  paramVinSearch() {
    if(this.paramVin) {
      iif(
        () => !!this.sourcetype,
        this.vehicleService.getVehicleFromVin(this.paramVin, this.sourcetype),
        this.vehicleService.getVehicleFromVin(this.paramVin)
      ).subscribe(result => {
        if (result?.data?.length) {
          const data = result.data[0]
          if (data.vin && data.make && data.model && data.year && this.searchWithVin) {
            this.load = false
            this.vehicleDetails.yearMakeModel = `${data.year} ${data.make} ${data.model}`
            this.vehicleDetails.vin = data.vin
            this.vehicleDetails.isInvalid = false
            this.vehicleDetails.make = data.make;
            this.vehicleDetails.certificationsStatus = data.certificationStatus;
            this.vehicleDetails.source = data.sourceSystem ? data.sourceSystem : data.source;
            this.vehicleDetails.stockNo = this.vehicleDetails.source === "Manual" ? data.licensePlate : data.stockNo;
            this.bannerService.showCarImage()
            this.bannerService.update(data.imageUrl)
            this.testDriveForm.get('vehicle').patchValue({
              model: data.model,
              year: data.year,
              make: data.make,
              imageUrl: data.imageUrl,
              vin: data.vin,
              source: data.sourceSystem ? data.sourceSystem : data.source,
              description: `${data.make} ${data.model}`,
              dealerCode: data?.dealerCode,
              unitId: data?.unitId ? data?.unitId : ""
            })
            this.isVinValid = true
          } else {
            this.load = false
            this.isVinValid = false
            this.vehicleDetails.isInvalid = false
            this.vehicleDetails.notAvailable = true
            this.vehicleDetails.yearMakeModel = ''
            this.vehicleDetails.vin = ''
          }
        } else {
          this.load = false
          this.isVinValid = false
          this.vehicleDetails.isInvalid = true
          this.vehicleDetails.yearMakeModel = ''
          this.vehicleDetails.vin = ''
        }
      });
      this.vinTestDrive = this.paramVin;
      this.searchWithVin = true;
      this.paramVin = '';
      this.sourcetype='';
    }
  }

  initializeTestDriveForm() {
    this.initializeOtherVehicleForm();

    /* Initialize main form group with sub forms */
    this.testDriveForm = this.formBuilder.group({
      vehicle:this.formBuilder.group({
        model: null,
        year: null,
        make: null,
        imageUrl:null,
        vin:null,
        source:null,
        description:null,
        unitId:null,
        dealerCode:null
      }),
      otherVehicles: this.otherVehiclesForm,
      tradeIn: this.tradeInForm,
      transportationTypeCode: ['', [Validators.required]],
      remoteZipCode: [''],
      availability: this.availability,
      customer: this.contactEmailInfoForm,
      address: this.customerForm
    });
    this.testDriveForm.controls.remoteZipCode.setValidators(this.zipValidator());
    this.onValueChange();
  }

  initializeOtherVehicleForm() {
    this.otherVehiclesForm = new UntypedFormArray([new UntypedFormGroup({
      year: new UntypedFormControl(''),
      model: new UntypedFormControl(''),
      trim: new UntypedFormControl('')
    })]);
  }

  zipValidator(): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors => {
      this.transport = this.testDriveForm.value.transportationTypeCode;
      if (this.testDriveForm.value.transportationTypeCode === 'REMOTE' && !this.isValidRemoteZip) {
        return { remoteZipCode: this.translateService.instant('service.invalidRemoteZipcode') };
      } else {
        return null;
      }
    };
  }


  setSignedInUserDetails() {
    this.subscriptions.customerSub = combineLatest([
      this.searchCustomersState.select(selectCurrentCustomer),
      this.searchCustomersState.select(selectPendingSearchInput)
    ]).subscribe(([customer, pendingSearchInput]) => {
        const isDrvaCustomer = customer?.drvaFlag === true;
        const fallbackFirstName = pendingSearchInput?.firstName || '';
        const fallbackLastName = pendingSearchInput?.lastName || '';
        const fallbackEmail = pendingSearchInput?.filterType === 'email' ? pendingSearchInput?.query : '';
        const fallbackPhone = pendingSearchInput?.filterType === 'phone' ? pendingSearchInput?.query : '';

        this.signedInUserDetails = {
          firstName: customer?.firstName || fallbackFirstName,
          lastName: customer?.lastName || fallbackLastName,
          emailAddress: isDrvaCustomer ? '' : (customer?.emailAddress || fallbackEmail),
          phoneNumber: isDrvaCustomer ? ' ' : (customer?.phoneNumber || fallbackPhone || ''),
          customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
          businessName: customer?.businessName || '',
          drvaFlag: customer?.drvaFlag || false
        //  customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
        //  businessName: customer?.businessName || '',
        };

        this.salesAppointmentState.dispatch(new fromActions.LoadCustomerDetails({ signedInUserDetails: this.signedInUserDetails }));
      });
  }

  checkZipCodes(value) {
    this.testDriveForm.controls.remoteZipCode.clearValidators();
    if (this.testDriveForm.value.transportationTypeCode === 'REMOTE') {
      this.subscriptions.remoteZip = this.remoteZipcodes$.pipe(
        filter(zip => !!zip?.length),
        take(1)).subscribe(zip => {
          this.remoteValidZipcodes = {pmaZipCodes:zip,isRemote:true};
          this.isValidRemoteZip = zip?.findIndex(x => x === value) !== -1;
          this.testDriveForm.controls.remoteZipCode.setValidators(this.zipValidator());
          this.testDriveForm.controls.remoteZipCode.updateValueAndValidity();
       
      });
    }
  }

  setupStoreValue() {
    this.setSignedInUserDetails();
    this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({appointmentType: AppointmentType.TEST_DRIVE}));
    this.availabilityOptions$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptions);
    this.availabilityOptionsLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptionsLoading);
    this.availability$ = this.salesAppointmentState.select(fromSelectors.getAvailability);
    this.availabilityLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityLoading);
    this.transportOptions$ = this.salesAppointmentState.select(fromSelectors.getTransportOptions);
    this.remoteZipcodes$ = this.salesAppointmentState.select(fromSelectors.getPMAZipCodes);
    this.yearList$ = this.salesAppointmentState.select(fromSelectors.getYearList);

    this.subscriptions.availabilityOptions = this.availabilityOptions$.subscribe(options => {
      this.hasRemoteLocation = !!options?.transport?.transportOptions?.find(x => x.category === LocationType.REMOTE && x.isActive && x.enableTestDriveType);
    });

    this.subscriptions.generalSettings = this.settingsState.select(fromSettingsSelectors.selectSettings).subscribe(settings => {
      if (settings && Object.entries(settings).length) {
        this.settings.time = settings.time;
        this.settings.portal = settings.portal;
        this.settings.dealerInfo = settings.dealerInfo;
        this.settings.isAspCrmIntegrationEnabled = settings.isAspCrmIntegrationEnabled;
        this.settings.isAspDmsIntegrationEnabled = settings.isAspDmsIntegrationEnabled;
        this.settings.isConsumerPortalEnabled = settings.isConsumerPortalEnabled;
        this.settings.isServiceAccessible = settings.isServiceAccessible;
      }
    });

    this.subscriptions.formStateValueSub = this.salesAppointmentState.select(fromSelectors.testDriveAppointmentDetails).subscribe((data) => {
      let value = {...data};
      const vehicleObj = {...value.vehicle}
      delete vehicleObj.exteriorColor
      delete vehicleObj.trim
      vehicleObj.description = `${vehicleObj.make} ${vehicleObj.model}`
      vehicleObj.dealerCode = value?.vehicle?.dealerCode
      vehicleObj.unitId = value?.vehicle?.unitId
      value.vehicle = vehicleObj
      
      if (_.isEqual(this.lastValue, value)) {
        return;
      }
      if(value.vehicle && value.vehicle.model && !value.vehicle.vin && this.lastValue && this.lastValue.vehicle.model !== value.vehicle.model){
        this.vehicleDetails$ = this.salesAppointmentState.select(fromSelectors.getVehicleDetails,
          { model: value.vehicle?.model, year: parseInt(value.vehicle?.year) || 0 });
      }
      if(value.vehicle && value.vehicle.vin && this.lastValue && this.lastValue.vehicle.vin !== value.vehicle.vin){
        const vehicle = { vin:value.vehicle.vin} as IVehicle;
      }
      if (value.vehicle && value.vehicle.trim && this.lastValue && this.lastValue.vehicle.trim !== value.vehicle.trim) {
        if(this.isUpdate|| this.vinTestDrive){
          this.bannerService.update(value.vehicle.imageUrl);
        }
        
      }
      this.languageId=value?.availability?.languageId;
      this.lastValue = value;
      this.isStoreUpdate = true;

      /*isUpdate -> During edit mode we need to store the state value thats coming in,
       so that we can check the incoming form changes against storeValue
       isStoreUpdate -> Phase 2 (basically used when changes are invoked from state during create mode)*/
      if (this.isUpdate || this.isStoreUpdate) {
        this.storeValue = { ...value };
        this.customerDataOnEdit = value.customer;
      }

      this.testDriveForm.patchValue(value);
      this.checkZipCodes(value.remoteZipCode);
      this.setOtherVehicles(value);
      if(value?.vehicle?.vin?.length && !this.vehicleDetailsEdit?.vin?.length && this.isUpdate){
        this.vehicleDetailsEdit = {
          yearMakeModel: `${data.vehicle.year} ${data.vehicle.make} ${data.vehicle.model}`,
          vin: data.vehicle.vin,
          stockno: 'P6392',
          trim: 'XE',
          certificationStatus:'',
          source:data.vehicle.source,
          make: data.vehicle.make,
          isEditMode: true,
          isTestDrive: true
        };
      }
    });
    this.subscriptions.currentCustomer = this.searchCustomersState.select(selectCurrentCustomer)
    .subscribe(customer => {
      this.isCustomerPanelExpanded = customer? false : true;
    })
  }

  setOtherVehicles(data) {
    if (this.isUpdate && data.otherVehicles) {
      this.otherVehicleChecked = data.otherVehicles[0] && !!data.otherVehicles[0].year;
      data.otherVehicles.forEach((element, i) => {
        if (!this.otherVehiclesArray.controls[i]) {
          this.otherVehiclesArray.push(new UntypedFormGroup({
            year: new UntypedFormControl(element.year),
            model: new UntypedFormControl(element.model),
            trim: new UntypedFormControl(element.trim)
          }));
        } else {
          this.otherVehiclesArray.controls[i].patchValue(new UntypedFormGroup({
            year: new UntypedFormControl(element.year),
            model: new UntypedFormControl(element.model),
            trim: new UntypedFormControl(element.trim)
          }));
        }
        this.otherVehiclesArray.controls[i].setValidators(this.setOtherVehicleValidator());
      });
    }
  }

  onValueChange() {
    this.subscriptions.testDriveSub = this.testDriveForm.valueChanges.subscribe(value => {
      //console.log('*** << MAIN form >> *** ', this.testDriveForm);
      // reset color and car image on changing the model
      // if (value.vehicle && value.vehicle.model && this.lastValue && this.lastValue.vehicle.model !== value.vehicle.model) {
      //   this.salesAppointmentState.dispatch(new fromActions.ResetExteriorColors());
      //   this.bannerService.update('');
      // }

      // to hit the EFC API for color and carImage only when trim is changed
      // if (value.vehicle && value.vehicle.trim && this.lastValue && this.lastValue.vehicle.trim !== value.vehicle.trim) {
      //   this.salesAppointmentState.dispatch(
      //     new fromActions.LoadExteriorColors({ year: value.vehicle.year, model: value.vehicle.model, trim: value.vehicle.trim }));
      // }
      //  initialize array of observables from otherVehicle FormArray
      
      this.setObservablesForOtherVehicles(value);

      if(value.vehicle?.vin && (this.vinTestDrive  || this.isUpdate)){
        this.vehicleDetails$ = this.salesAppointmentState.select(fromSelectors.getVehicleDetailsForVin,
          { model: value.vehicle?.model, year: value.vehicle?.year });
        
      }else{
      // initializing vehicle-configurators selector
      this.vehicleDetails$ = this.salesAppointmentState.select(fromSelectors.getVehicleDetails,
        { model: value.vehicle?.model, year: value.vehicle?.year });
     }
     const val = _.cloneDeep(value)
     if(value?.vehicle?.model && this.isUpdate) {
      const obj = {...this.vehicleDetails}
      obj.source = value.vehicle.source
      obj.yearMakeModel = `${value.vehicle.year} ${value.vehicle.make} ${value.vehicle.model}`;
      obj.vin = value.vehicle.vin;
      this.vehicleDetails = obj
     }

            // to disable vehicle in Edit Mode
      if (this.subscriptions.vehicleDetailSub) {
        this.subscriptions.vehicleDetailSub.unsubscribe();
      }
      this.subscriptions.vehicleDetailSub = this.vehicleDetails$.subscribe(item => {
        if (item && item.modelList?.length !== 0 && item.exteriorColors?.length !== 0 && (this.isUpdate||this.vinTestDrive)) {
          if (value.vehicle.exteriorColor) {
            this.bannerService.update(item.exteriorColors.find(x => x.id === value.vehicle.exteriorColor)?.carImage);
          }
        }
      });

      /*Updating storeValue = undefined everytime the form is updated to the initial changes from the state */
      if (this.storeValue && _.isEqual(this.storeValue, val)) {
        this.storeValue = undefined;
        this.isStoreUpdate = false;
        if(this.isUpdate && !this.storeValue){
          return
        }
        /* for the very first time lastValue, storeValue and value will be equal,
         hence the storeValue will be undefined. To handle this scenario we are
         reassigning the same value from the store*/
        if (_.isEqual(this.lastValue, value)) {
          this.storeValue = this.lastValue;
        }
        return;
      }

      if (_.isEqual(this.lastValue, value)) {
        return;
      }

      if ((value.transportationTypeCode && this.lastValue.transportationTypeCode !== value.transportationTypeCode) || (value.vehicle.vin && this.lastValue.vehicle.vin !== value.vehicle.vin)) {
        this.isStoreUpdate = true;
        this.testDriveVins = value.vehicle.vin;
        /* *vin is available then only call the availability*/
        if(this.testDriveVins){
          this.loadingAvailability = false;
          const chosenDate = value.availability.appointmentStartDate;
          if (!!chosenDate) {
            const date = DateTime.fromISO(chosenDate)
              .startOf('month')
              .toFormat('yyyy-MM-dd');  
            this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
                { selectDateAndSlot: true, date, advisorId: value.availability.advisorId, 
                transport: value.transportationTypeCode, vin: value.vehicle.vin, 
                appointmentType: AppointmentType.TEST_DRIVE ,appointmentId : this.appointmentId ? this.appointmentId : ''}));
          } else {
            this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
              { selectDateAndSlot: false, date: '', advisorId: value.availability.advisorId, 
              transport: value.transportationTypeCode, vin: value.vehicle.vin, 
              appointmentType: AppointmentType.TEST_DRIVE,appointmentId : this.appointmentId ? this.appointmentId : ''}));
          }
          this.availabilityLoading$.subscribe(value => {
            if(!value){
              this.loadingAvailability = true;
            }
          })
          if(this.lastValue.transportationTypeCode !== value.transportationTypeCode){
            this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({appointmentType: AppointmentType.TEST_DRIVE}));
          }  
        }
      }else{
        this.isStoreUpdate = false;
      } 

      /*lastValue keeps changing everytime the form value changes
       (even when the changes are from the initialstate or EditState) */
      this.lastValue = value;
      const vehicle:IVehicle = {...value.vehicle,vin:this.vinTestDrive}
      if(!this.vinTestDrive){
        delete vehicle.vin;
      }
      if (value?.customer?.emailAddress) {
        value.customer.emailAddress = value.customer.emailAddress.trim();
      }
      /*dispatch happens only when the storeValue = undefined which means
      that all the initial changes (initialState and EditState) from store are
      populated in the form and now we are dispatching the changes done by the user*/
      if (!this.storeValue) {
        this.salesAppointmentState.dispatch(new fromActions.UpdateSalesFormData({ value,...vehicle }));
      }
  //    this.subscriptions.testDriveSub.unsubscribe();
      this.validVehicleForm = this.checkvehicleForm(this.testDriveForm?.controls?.vehicle?.value) ? this.checkvehicleForm(this.testDriveForm?.controls?.vehicle?.value) : false;
    });

  }

  setObservablesForOtherVehicles(value) {
    if (value.otherVehicles.length && this.lastValue) {
      value.otherVehicles.forEach((element, i) => {

        // reset dropdown values of model and trim if the year is changed
        if (this.lastValue.otherVehicles[i] && value.otherVehicles[i].year !== this.lastValue.otherVehicles[i].year) {
          this.modelList$.splice(i, 1);
          this.trimList$.splice(i, 1);
        }

        // reset dropdown values of trim if the model is changed
        if (this.lastValue.otherVehicles[i] && value.otherVehicles[i].model !== this.lastValue.otherVehicles[i].model) {
          this.trimList$.splice(i, 1);
        }

        // adding observables to the array only when 'Add Vehicle' is clicked
        if (i === this.modelList$.length && value.otherVehicles[i].year && this.modelList$.length !== value.otherVehicles.length) {
          this.modelList$.push(this.salesAppointmentState.select(fromSelectors.getOtherVehiclesSeriesList({ year: value.otherVehicles[i]?.year })));
        }

        if (i === this.trimList$.length && value.otherVehicles[i].year &&
          value.otherVehicles[i].model && this.trimList$.length !== value.otherVehicles.length) {
          this.trimList$.push(this.salesAppointmentState.select(fromSelectors.getOtherVehiclesTrimList,
            { model: value.otherVehicles[i]?.model, year: value.otherVehicles[i]?.year }));
        }
      });
    }
  }

  get otherVehiclesArray() {
    return this.testDriveForm.get('otherVehicles') as UntypedFormArray;
  }

  onAddVehicle() {
    this.otherVehiclesArray.push(new UntypedFormGroup({
      year: new UntypedFormControl(''),
      model: new UntypedFormControl(''),
      trim: new UntypedFormControl('')
    }));
    const index = this.otherVehiclesArray.length - 1;
    (this.otherVehiclesArray.controls[index] as UntypedFormGroup).setValidators(this.setOtherVehicleValidator());
  }

  onDeleteVehicle(index: number) {
    this.otherVehiclesArray.removeAt(index);
    this.modelList$.splice(index, 1);
    this.trimList$.splice(index, 1);
  }

  checkCustomerForm() {
    const customer = this.testDriveForm.controls.customer.value;
    const hasValidCustomerName = (customer?.customerType !== CustomerType.BUSINESS
      && customer?.firstName?.length > 0
      && customer?.lastName?.length > 0)
      || (customer?.customerType === CustomerType.BUSINESS
      && customer?.businessName?.length > 0);

    return this.testDriveForm.controls.address.value
      && hasValidCustomerName
      && this.checkIfEmailOrPhoneValid();
  }

  checkIfEmailOrPhoneValid()
  {
    /* check if email or phone entered */
    if(this.testDriveForm.controls.customer.value.emailAddress || this.testDriveForm.controls.customer.value.phoneNumber)
    {
      return this.testDriveForm.controls['customer'].valid;
    }
 
    /*return false if none is entered,either has to be entered*/
    return false;
  }

  checkvehicleForm(form){
    if(this.searchWithVin){
    if(form?.source === SourceSystem.NVI){
      return form?.make?.length>0 && form?.model?.length>0 && form?.year && form?.unitId && form?.description &&  form?.imageUrl?.length >0
      && form?.vin?.length > 0
    }else if(form?.source === SourceSystem.UVI){
      return form?.make?.length>0 && form?.model?.length>0 && form?.year && form?.description?.length
      && form?.vin?.length > 0
    }else{
      return form?.make?.length >0 && form?.model?.length>0 && form?.year && form?.description?.length > 0 && form?.vin?.length >0
    }
  }else{
    return form?.source?.length && form?.make?.length>0 && form?.year && form?.model?.length>0
  }
  }

  checkIfAvaiabilityValid(){
      return this.AvailabilityComponent?.timeSlots?.filter(slot => slot?.timeSlotId === this.AvailabilityComponent?.oldValue?.timeSlotId)[0]?.isOpen
  }

  isValidTestdriveFrom() {
    return (this.testDriveForm.controls.availability.valid && 
      this.checkIfAvaiabilityValid() &&
      this.loadingAvailability &&
      this.testDriveForm.controls.transportationTypeCode.valid &&
      this.testDriveForm.controls.address.valid &&
      this.testDriveForm.controls.tradeIn.valid &&
      this.testDriveForm.controls.otherVehicles.valid &&
      this.testDriveForm.controls.remoteZipCode.valid &&
      this.checkvehicleForm(this.testDriveForm?.controls?.vehicle?.value) && this.checkCustomerForm());
  }

  isValidForm() {
    const apptStartDate = this.testDriveForm.get('availability').value?.appointmentStartDate || "";
    const currentDate = DateTime.fromISO(DateTime.now().toString())
    .toFormat(this.dateFormat);
    return !this.vehicleDetails.isInvalid && this.isValidTestdriveFrom() && apptStartDate>=currentDate
  }

  onSubmit() {
    this.isSubmitting = true;
    if (this.isUpdate) {
      const payload = {appointmentType : AppointmentType.TEST_DRIVE,searchWithVin:this.searchWithVin,settings:this.settings}
      this.salesAppointmentState.dispatch(new fromActions.EditSalesAppointment(payload));
    } else {
      const payload = {appointmentType : AppointmentType.TEST_DRIVE,searchWithVin:this.searchWithVin,settings:this.settings}
      this.salesAppointmentState.dispatch(new fromActions.CreateSalesAppointment(payload));
    }
    this.subscriptions.editDetailsSub = this.salesAppointmentState.select(fromSelectors.editDetails)
      .subscribe((editDetail) => {
        this.onSubmitting(editDetail);
      });
  }

  onSubmitting(data) {
    if (data) {
      if (!data.isSubmitted) {
        this.isSubmitting = false;
      }
      if (data.isSubmitted) {
        this.valueChanged=true;
        const urlState = {...data.appointmentData};   
        const navigationExtras: NavigationExtras = {
          queryParams: {
            id: data.appointmentId
          },
          state: urlState
        };
        this.router.navigate(['asp/bdc/testdrive/confirm'], navigationExtras);
      }
    }
  }

  onMonthChange($event: DateTime) {
    this.subscriptions.availability = this.salesAppointmentState.select(fromSelectors.getAvailabilityDetails)
       .pipe(take(1))
       .subscribe(details => {
        const date = $event.toFormat(this.dateFormat);
         this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
           { selectDateAndSlot: false, date, advisorId: details.advisorId, transport: details.transport, vin: this.testDriveVins, appointmentType: AppointmentType.TEST_DRIVE,appointmentId : this.appointmentId ? this.appointmentId : ''}));
       });

  }

  onOtherVehicleChecked() {
    this.otherVehicleChecked = !this.otherVehicleChecked;
    if (this.otherVehiclesArray.length) {
      this.otherVehiclesArray.controls.forEach((a, i) => {
        if (this.otherVehicleChecked) {
          a.setValidators(this.setOtherVehicleValidator());
          a.updateValueAndValidity();
        } else {
          this.removeOtherVehicleValidator(i);
          this.otherVehiclesArray.reset();
        }
      });
    }
  }

  setOtherVehicleValidator(): ValidatorFn {
    return (vehicle: UntypedFormGroup): ValidationErrors => {

      if (this.otherVehicleChecked) {
        this.validatedFields.forEach(fields => {
          if (!vehicle.controls[fields].value) {
            vehicle.controls[fields].setErrors({ required: `${fields} ${this.translateService.instant('service.isRequired')}` });
          }
        });
      }
      return;
    };
  }

  removeOtherVehicleValidator(index: number) {
    const vehicle = this.otherVehiclesArray.controls[index] as UntypedFormGroup;
    this.validatedFields.forEach(field => vehicle.controls[field].setErrors(null, { emitEvent: false }));
    if (index !== 0) {
      this.otherVehiclesArray.removeAt(index);
    }
  }

  backToDashboard() {
    this.router.navigate(['asp/bdc/dashboard']);
  }

  get getDisclaimerText() {
    return this.translateService.instant('testDrive.privacyPolicyTxt');
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
    this.salesAppointmentState.dispatch(new fromActions.ResetSalesAppointmentState());
    this.bannerService.update('');
    this.cd.detach();
  }
  getTranslation(value){
    return value ? `${this.translateService.instant(`common.${value}`)}` : value;
  }
}
